import React, { useState } from 'react';
import { getAchievementsData, calculateUnlockProgress } from '../data/dailyChallengesData';

const AchievementsPage = ({ language = 'traditional', onBack, onShareAchievement }) => {
  const achievementsData = getAchievementsData();
  const [selectedCategory, setSelectedCategory] = useState('all');
  const progress = calculateUnlockProgress();

  const getText = (textObj) => {
    return textObj[language] || textObj.traditional;
  };

  const getFilteredAchievements = () => {
    switch (selectedCategory) {
      case 'unlocked':
        return achievementsData.achievements.filter(a => a.isUnlocked);
      case 'in_progress':
        return achievementsData.achievements.filter(a => !a.isUnlocked);
      default:
        return achievementsData.achievements;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white">
      {/* Header */}
      <div className="px-6 py-6">
        <div className="flex items-center justify-between mb-6">
          <button onClick={onBack} className="text-white">
            ←
          </button>
          <h1 className="text-xl font-bold">
            {getText(achievementsData.title)}
          </h1>
          <div className="w-8"></div> {/* Spacer for centering */}
        </div>

        {/* Unlock Progress Card */}
        <div className="bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl p-6 mb-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold">
              {getText(achievementsData.unlockProgress.title)}
            </h2>
            <div className="text-yellow-400 text-xl">🏅</div>
          </div>
          
          <div className="text-center mb-4">
            <div className="text-3xl font-bold mb-2">
              {progress.unlocked} / {progress.total}
            </div>
            <div className="w-full bg-gray-700 rounded-full h-2">
              <div
                className="bg-yellow-400 h-2 rounded-full transition-all duration-300"
                style={{ width: `${progress.progress}%` }}
              />
            </div>
          </div>
        </div>

        {/* Category Filters */}
        <div className="flex space-x-2 mb-6">
          {achievementsData.categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                selectedCategory === category.id
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-700 text-gray-300'
              }`}
            >
              {getText(category.title)}
            </button>
          ))}
        </div>

        {/* Achievements Grid */}
        <div className="grid grid-cols-2 gap-4 mb-8">
          {getFilteredAchievements().map((achievement) => (
            <div
              key={achievement.id}
              className={`bg-gradient-to-br ${achievement.gradient} rounded-xl p-4 text-center`}
            >
              <div className="text-3xl mb-3">{achievement.icon}</div>
              <h3 className="font-semibold text-white mb-2">
                {getText(achievement.title)}
              </h3>
              <p className="text-sm text-gray-200 mb-3">
                {getText(achievement.description)}
              </p>
              
              {achievement.isUnlocked && achievement.status && (
                <div className="flex items-center justify-center space-x-1">
                  <span className={achievement.statusColor}>{achievement.statusIcon}</span>
                  <span className="text-xs text-gray-200">
                    {getText(achievement.status)}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Share Achievement Button */}
        <button
          onClick={onShareAchievement}
          className="w-full bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-semibold py-4 px-6 rounded-xl transition-colors flex items-center justify-center space-x-2"
        >
          <span className="text-xl">{achievementsData.shareButton.icon}</span>
          <span>{getText(achievementsData.shareButton.title)}</span>
        </button>
      </div>
    </div>
  );
};

export default AchievementsPage;
